module.exports = __webpack_public_path__ + "media/images/home/screen_13-39e479e5c736c081dc658d244877cda5.png";